import React, {PropTypes} from 'react';
import {Field, reduxForm} from 'redux-form';
import {emitEvent} from '../../lib/mz';
import CustomInput from './CustomInput';

const SearchForm = (props) => {
  const {q, contextType, handleSubmit, searchSubmit, changeKeyword, widgetType} = props;
  const mzClick = (eventTitle) => emitEvent('CLICK', {eventTitle, keyword: q, module: {type: widgetType}});

  return (
    <form className="search-form" onSubmit={handleSubmit(() => { mzClick('search-submit'); return searchSubmit(q, contextType); })}>
      <div className="search-form__input-container">
        <Field
          name="q"
          id="search"
          keyword={q}
          component={CustomInput}
          placeholder="Search answers"
          classNames="search-form__input"
          required="required"
          onChange={(e) => { changeKeyword(e.target.value); }}
        />
        <div className="search-form__button">
          <button type="submit" className="tes-btn">
            <span className="icon-search-rebrand">Search</span>
          </button>
        </div>
      </div>
    </form>
  );
};

SearchForm.propTypes = {
  q: PropTypes.string,
  contextType: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  searchSubmit: PropTypes.func.isRequired,
  changeKeyword: PropTypes.func.isRequired,
  widgetType: PropTypes.string.isRequired,
};

export default reduxForm({
  form: 'search',
})(SearchForm);
